import isEqual from 'lodash.isequal';
export var depsAreEqual = function depsAreEqual(deps1, deps2) {
  return isEqual(deps1, deps2);
};
export var getDepNames = function getDepNames(deps) {
  return Object.keys(deps || {});
};
export var getUpdatedDeps = function getUpdatedDeps(depNames, currentData) {
  var updatedDeps = {};
  depNames.forEach(function (depName) {
    updatedDeps[depName] = currentData[depName];
  });
  return updatedDeps;
};